
import { FacebookOutlined, InstagramOutlined, WhatsAppOutlined, PhoneOutlined, ClockCircleOutlined, EnvironmentOutlined } from '@ant-design/icons';
import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';

const Footer = () => (
  <footer className="ch-footer">
    <div className="ch-footer-main">
      <div className="ch-footer-content">
        {/* Brand Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="ch-footer-brand"
        >
          <div className="ch-footer-logo">
            <Image 
              src="/assets/images/chethisLogo.svg" 
              alt="Chethi's - Luxury Eco-Friendly Fashion" 
              width={180} 
              height={60} 
              className="ch-footer-logo-img"
            />
          </div>
          <p className="ch-footer-tagline">
            Crafting dreams into reality with sustainable luxury fashion
          </p>
          <div className="ch-footer-certifications">
            <div className="ch-footer-cert">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
              <span>Premium Quality</span>
            </div>
            <div className="ch-footer-cert">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22L6.66 19.7C7.14 19.87 7.64 20 8 20C19 20 22 3 22 3C21 5 14 5.25 9 6.25C4 7.25 2 11.5 2 13.5C2 15.5 3.75 17.25 3.75 17.25C7.5 13 17 8 17 8Z" fill="currentColor"/>
              </svg>
              <span>Eco-Friendly</span>
            </div>
          </div>
        </motion.div>

        {/* Quick Links */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          viewport={{ once: true }}
          className="ch-footer-links"
        >
          <h3 className="ch-footer-section-title">Quick Links</h3>
          <ul className="ch-footer-link-list">
            <li><Link href="/shop">Shop All</Link></li>
            <li><Link href="/shop/eco-bag">Eco Bags</Link></li>
            <li><Link href="/shop/cushion-covers">Cushion Covers</Link></li>
            <li><Link href="/shop/frocks">Frocks</Link></li>
            <li><Link href="/about-us">About Us</Link></li>
            <li><Link href="/contact-us">Contact</Link></li>
          </ul>
        </motion.div>

        {/* Contact Info */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="ch-footer-contact"
        >
          <h3 className="ch-footer-section-title">Get in Touch</h3>
          <div className="ch-footer-contact-info">
            <div className="ch-footer-contact-item">
              <EnvironmentOutlined className="ch-footer-contact-icon" />
              <div>
                <strong>Address</strong>
                <p>Karawwa, Pitigala<br />Galle, Sri Lanka</p>
              </div>
            </div>
            <div className="ch-footer-contact-item">
              <PhoneOutlined className="ch-footer-contact-icon" />
              <div>
                <strong>Phone</strong>
                <p><Link href="tel:+94776411718">(+94) 77 641 1718</Link></p>
              </div>
            </div>
            <div className="ch-footer-contact-item">
              <ClockCircleOutlined className="ch-footer-contact-icon" />
              <div>
                <strong>Hours</strong>
                <p>Mon - Sat: 09:00 - 17:00</p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Social Media */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="ch-footer-social"
        >
          <h3 className="ch-footer-section-title">Follow Our Journey</h3>
          <p className="ch-footer-social-text">
            Stay connected for the latest collections and sustainable fashion tips
          </p>
          <div className="ch-footer-social-links">
            <Link 
              target="_blank" 
              href="https://www.facebook.com/share/ZVT5zPEhndhsPvsu/?mibextid=qi2Omg"
              className="ch-footer-social-link facebook"
              aria-label="Follow us on Facebook"
            >
              <FacebookOutlined />
            </Link>
            <Link 
              target="_blank" 
              href="https://www.instagram.com/chethi.s_?utm_source=qr&igsh=Y3dpc2kxMG5zMzM="
              className="ch-footer-social-link instagram"
              aria-label="Follow us on Instagram"
            >
              <InstagramOutlined />
            </Link>
            <Link 
              target="_blank" 
              href="https://wa.me/94776411718"
              className="ch-footer-social-link whatsapp"
              aria-label="Contact us on WhatsApp"
            >
              <WhatsAppOutlined />
            </Link>
          </div>
        </motion.div>
      </div>
    </div>

    {/* Footer Bottom */}
    <div className="ch-footer-bottom">
      <div className="ch-footer-bottom-content">
        <div className="ch-footer-copyright">
          <p>© 2025 Chethi&apos;s. All rights reserved.</p>
        </div>
        <div className="ch-footer-credits">
          <p>Crafted with ❤️ by <Link href="#" target="_blank">Lahiru</Link></p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
